export default {
    /**
   * @description token在Cookie中存储的天数，默认1天
   */
    cookieExpires: 0.0035, // 5分钟
    /**
   * @description api请求基础路径
   */
    baseUrl: {
        dev: '/api',
        pro: window.location.origin, // 自动匹配域名
        cdnUrl: 'https://cdn.juplus.cn/',
    }
}
